import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/B4_Remaining_time.svg"

const B4RemainingTime: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 30 30'} component={Icon} {...props} fill="currentColor" />
export default B4RemainingTime
